import React from 'react';
import { useSelector } from 'react-redux';
import NavigateLink from '../navigateLink/navigateLink';
import { resolveBucketImageSrc } from '../../../utils/utils';
import gaSectionType from '../../../enums/gaSectionType';
import classes from './UsefulTool.module.css';

export const getUsefulToolLink = (tool, userDetails) => {
    if (tool?.visibleTo?.useSchoolLink && userDetails?.defaultSchool) {
        const schoolLink = userDetails.defaultSchool[tool?.visibleTo?.useSchoolLink];
        if (schoolLink) {
            return schoolLink;
        }
    }
    if (tool?.link) {
        return tool.link;
    }
};

const UsefulTool = ({ tool, size = 'default', disableLink = false }) => {

    const { userDetails } = useSelector(state => state.auth);
    const toolLink = getUsefulToolLink(tool, userDetails);

    const icon = (
        <div className={size === 'small' ? classes.ToolIconSmall : classes.ToolIcon}>
            <img
                src={tool.imageUrl || tool.picture}
                alt={tool.title}
                className={size === 'small' ? classes.ToolImageSmall : classes.ToolImage}
            />
        </div>
    );

    if (disableLink || !toolLink) {
        return icon;
    }

    return (
        <NavigateLink link={toolLink} ga={{ section: gaSectionType.tools }} onClick={(e) => e.stopPropagation()}>
            <div className={size === 'small' ? classes.ToolIconSmall : classes.ToolIcon}>
                <img src={resolveBucketImageSrc(tool.imageUrl || tool.picture)} alt={tool.title} className={size === 'small' ? classes.ToolImageSmall : classes.ToolImage} />
            </div>
        </NavigateLink>
    );
};

export default UsefulTool;
